import React, { useEffect, useState } from 'react'

import GenderSex from './graphs/GenderSex'
import moment from 'moment'

function Pie(props) {
	const [show, setShow] = useState(null)
	useEffect(() => {
		if (props.usersagegender?.hasOwnProperty('secondRange') && props.multipleState.compare) {
			setShow(true)
		} else {
			setShow(false)
		}
	}, [props.usersagegender, props.multipleState.compare])
	return (
		<div style={{ width: '100%', padding: 20 }}>
			<h2>Répartition des Tranches d’âge</h2>
			<div
				style={{
					display: show ? 'flex' : 'block',
					justifyContent: 'space-between',
					marginTop: 20,
				}}
			>
				<>
					<p
						style={{
							fontWeight: 'bold',
							textAlign: 'left',
							marginTop: 30,
							position: 'absolute',
							color: 'rgb(61, 145, 255)',
						}}
					>
						{moment(new Date(props.multipleState.selection.startDate)).format(
							'YYYY/MM/DD'
						)}{' '}
						-{' '}
						{moment(new Date(props.multipleState.selection.endDate)).format(
							'YYYY/MM/DD'
						)}
					</p>
					<GenderSex show={show} usersagegender={props.usersagegender?.firstRange} />
				</>
				{show && props.multipleState.compare && (
					<>
						<p
							className='compare'
							style={{
								fontWeight: 'bold',
								position: 'absolute',
								left: '50%',
								marginTop: 30,
								color: 'rgb(62, 207, 142)',
							}}
						>
							{moment(new Date(props.multipleState.compare.startDate)).format(
								'YYYY/MM/DD'
							) +
								' - ' +
								moment(new Date(props.multipleState.compare.endDate)).format(
									'YYYY/MM/DD'
								)}
						</p>
						<GenderSex show={show} usersagegender={props.usersagegender?.secondRange} />{' '}
					</>
				)}
			</div>
		</div>
	)
}

export default Pie
